// extracted by mini-css-extract-plugin
export default {"container":"SportAll_container__ymIUA","leagueContainer":"SportAll_leagueContainer__JDC8+"};